import React from 'react';
import './HomeBan.css';
import HOMEBAN from '../images/VID/HOMEBAN.mp4';
import MODERNHOUSE from '../images/MODERNHOUSE.jpeg';

export default function HomeBan() {
  return (
    <section className="hero-banner-section" aria-label="VARK Builders Hero Showcase">
      <div className="hero-video-frame">
        <video
          autoPlay
          muted
          loop
          playsInline
          poster={MODERNHOUSE}
          className="hero-main-video"
          preload="auto"
          title="VARK Builders - Your Dream Home, Our Expertise"
        >
          <source src={HOMEBAN} type="video/mp4" />
          Your browser does not support HTML5 video.
        </video>
      </div>
    </section>
  );
}
